<script setup lang="ts">
import { ref } from "vue";
import PageContainer from "~/components/ui/PageContainer.vue";
import { buildComputerCollectionSchema } from "~/features/computer/data/seo/computer-schema";

const openQuestion = ref<string | null>(null);

const questions = [
  {
    id: "py-long-1",
    question: "Variables ko simple example ke sath explain karo.",
    steps: [
      "Variable aik naam wala storage hota hai.",
      "Is me value temporarily store hoti hai.",
      "Python me assignment se variable banta hai, jaise x = 10.",
      "Example: marks = 85",
    ],
    link: "/11th/computer/python/notes/",
  },
  {
    id: "py-long-2",
    question: "If else statement ka use explain karo.",
    steps: [
      "If else condition check karta hai.",
      "Agar condition true ho to if wala code chalta hai.",
      "Agar condition false ho to else wala code chalta hai.",
      "Example: agar marks 40 se zyada hon to pass warna fail.",
    ],
    link: "/11th/computer/python/notes/",
  },
  {
    id: "py-long-3",
    question: "For loop aur while loop me farq explain karo.",
    steps: [
      "For loop fixed ya clear repetition ke liye use hota hai.",
      "While loop condition true rehne tak chalta hai.",
      "For loop list ya range ke sath common hota hai.",
      "While loop tab useful hota hai jab stop point condition se decide ho.",
    ],
    link: "/11th/computer/python/notes/",
  },
  {
    id: "py-long-4",
    question: "Function kya hota hai aur kyun use karte hain?",
    steps: [
      "Function code ka reusable block hota hai.",
      "Is se same code bar bar likhna nahi padta.",
      "Function parameters le sakta hai.",
      "Function return ke zariye result wapas de sakta hai.",
    ],
    link: "/11th/computer/python/notes/",
  },
] as const;

function toggleQuestion(id: string) {
  openQuestion.value = openQuestion.value === id ? null : id;
}

usePageSeo({
  title: "Chapter 2 Python Long Questions | Ustaad",
  description: "11th class Python chapter ke long questions structured answers ke sath.",
  breadcrumbs: [
    { name: "Home", item: "/" },
    { name: "11th Computer", item: "/11th/computer/" },
    { name: "Ch 2 Python", item: "/11th/computer/python/" },
    { name: "Long Questions", item: "/11th/computer/python/long-questions/" },
  ],
  schemaType: "CollectionPage",
  schemaProperties: buildComputerCollectionSchema({
    about: "Chapter 2 Python Long Questions",
    items: [
      { name: "Chapter 2 Python", path: "/11th/computer/python/" },
      { name: "Chapter 2 Python MCQs", path: "/11th/computer/python/mcqs/" },
      { name: "Chapter 2 Python Short Questions", path: "/11th/computer/python/short-questions/" },
      { name: "Pairing Scheme", path: "/11th/computer/pairing-scheme/" },
      { name: "Guess Paper", path: "/11th/computer/guess-paper/" },
    ],
  }),
});
</script>

<template>
  <PageContainer>
    <div class="space-y-8">
      <section class="rounded-3xl bg-slate-950 p-6 text-white">
        <h1 class="text-2xl font-bold tracking-tight">Chapter 2 Python Long Questions</h1>
        <p class="mt-3 text-sm leading-7 text-slate-200">Variables, conditions, loops aur functions ke long answers ko step by step revise karo.</p>
      </section>

      <section class="space-y-4 rounded-3xl border border-slate-200 bg-white p-5">
        <div v-for="question in questions" :key="question.id" class="rounded-2xl bg-slate-50 p-4 ring-1 ring-slate-200">
          <div class="flex items-center justify-between gap-3">
            <p class="text-sm font-semibold text-slate-900">{{ question.question }}</p>
            <button type="button" class="rounded-full border border-slate-300 px-3 py-1 text-sm font-medium text-slate-800" @click="toggleQuestion(question.id)">
              {{ openQuestion === question.id ? "Jawab chhupao" : "Jawab dekho" }}
            </button>
          </div>
          <div v-if="openQuestion === question.id" class="mt-4 space-y-3">
            <ol class="space-y-2 text-sm text-slate-700">
              <li v-for="(step, index) in question.steps" :key="`${question.id}-${index}`">{{ index + 1 }}. {{ step }}</li>
            </ol>
            <NuxtLink :to="question.link" class="inline-flex text-sm font-medium text-sky-700 underline decoration-sky-300 underline-offset-4">
              Yeh topic dobara parho ->
            </NuxtLink>
          </div>
        </div>
      </section>
    </div>
  </PageContainer>
</template>
